<flx-resources-grid
  [tableDef]="tableColumnsDef"
  [items]="items()"
  [rowClickEnabled]="false"
  class="h-full"
  emptyMsg="No processes"
  emptyMsgDescription="Process instances started by this session appear here."
  emptyMsgIcon="ph ph-tree-structure"
/>
